;
var sprite = require("/tmp/build_133e1b25/node_modules/svg-sprite-loader/lib/web/global-sprite");;
var image = "<symbol viewBox=\"0 0 100 100\" id=\"Vitra_Collection_6356d89558770574e301d52266b6add2\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <g> <g> <path d=\"M16.44,87.039h57.216v-59.67H16.44V87.039z M21.015,31.65h48.068v51.109H21.015V31.65z\"/> <polygon points=\"26.444,17.466 26.444,21.747 78.985,21.747 78.985,76.971 83.56,76.971 83.56,17.466 \t\t\"/> </g> </g> </symbol>";
module.exports = sprite.add(image, "Vitra_Collection_6356d89558770574e301d52266b6add2");


//////////////////
// WEBPACK FOOTER
// ./images/icons/Vitra_Collection.svg
// module id = 1405
// module chunks = 0